
import { useScrollAnimation } from '../../../hooks/useScrollAnimation';

export default function CompanyOverview() {
  const { ref, isVisible } = useScrollAnimation();

  const infoItems = [
    {
      labelJa: '会社名',
      labelEn: 'Company Name',
      value: 'ビットムーブスジャパン株式会社\nBITMOVES Japan Inc.',
    },
    { labelJa: '代表者', labelEn: 'CEO', value: '田村 善幸' },
    { labelJa: '設立', labelEn: 'Founded', value: '2024年2月' },
    {
      labelJa: '所在地',
      labelEn: 'Address',
      value:
        '東京都千代田区丸の内1-11-1\nパシフィックセンチュリープレイス丸の内13F',
    },
    { labelJa: '資本金', labelEn: 'Capital', value: '100万円' },
    { labelJa: 'メール', labelEn: 'Email', value: 'inquiry@bitmoves.jp' },
    { labelJa: 'URL', labelEn: 'Website', value: 'https://bitmoves.jp' },
  ];

  return (
    <section ref={ref} className="bg-white py-32 lg:py-40 px-8 lg:px-32">
      <div className="max-w-5xl mx-auto">
        <div
          className={`mb-16 transition-all duration-700 ${
            isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
          }`}
        >
          <h2 className="text-4xl lg:text-5xl font-medium text-gray-900 mb-3">
            会社概要
          </h2>
          <p className="text-base text-gray-500">Company Information</p>
        </div>

        <div
          className={`transition-all duration-700 delay-200 ${
            isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
          }`}
        >
          {infoItems.map((item, index) => (
            <div
              key={index}
              className="grid grid-cols-1 lg:grid-cols-[200px_1fr] gap-2 lg:gap-8 py-7 border-b border-gray-100"
            >
              <div>
                <p className="text-sm font-medium text-gray-900">{item.labelJa}</p>
                <p className="text-xs text-gray-400">{item.labelEn}</p>
              </div>
              <div>
                {item.value.split('\n').map((line, i) => {
                  if (item.labelJa === 'メール') {
                    return (
                      <a
                        key={i}
                        href={`mailto:${line}`}
                        className="text-sm text-gray-700 hover:text-gray-900 transition-colors cursor-pointer block leading-relaxed"
                      >
                        {line}
                      </a>
                    );
                  }
                  if (item.labelJa === 'URL') {
                    return (
                      <a
                        key={i}
                        href={line}
                        target="_blank"
                        rel="noopener noreferrer nofollow"
                        className="text-sm text-gray-700 hover:text-gray-900 transition-colors cursor-pointer block leading-relaxed"
                      >
                        {line}
                      </a>
                    );
                  }
                  return (
                    <p
                      key={i}
                      className="text-sm text-gray-700 leading-relaxed"
                    >
                      {line}
                    </p>
                  );
                })}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
